import { ADD_FILE, DELETE_FILE, GET_FILES_REQUEST, GET_FILES_SUCCESS, RESET_TO_INITIAL } from "./constants";

const addFileAction = (payload) => ({ type: ADD_FILE, payload });
const deleteFileAction = (payload) => ({ type: DELETE_FILE, payload });
const getFilesRequestAction = (payload) => ({ type: GET_FILES_REQUEST, payload });
const getFilesSuccessAction = (payload) => ({ type: GET_FILES_SUCCESS, payload });
const resetToInitialAction = () => ({ type: RESET_TO_INITIAL });

export { addFileAction, deleteFileAction, getFilesSuccessAction, getFilesRequestAction, resetToInitialAction };
